<div class="rollover">
  <img
    class="rollover__image"
    *ngIf="content.header.loaded"
    [src]="getImageSource(content.header.banner)"
    [alt]="content.header.banner.desktop.alt"
  />
</div>
<div class="rollover__container">
  <div
    [skeletonMetaData]="{
      loaded: content.header.loaded,
      error: content.header.error,
      disabled: content.header.disabled
    }"
    (action)="openLink.emit($event)"
    auraSkeletonLoader
  >
    <idp-header
      *ngIf="content.header.title"
      [content]="content.header"
    ></idp-header>
  </div>

  <div
    [skeletonMetaData]="{
      loaded: content.status.loaded,
      error: content.status.error,
      disabled: content.status.disabled
    }"
    (action)="openLink.emit($event)"
    auraSkeletonLoader
  >
    <idp-status
      *ngIf="content.status.level"
      [content]="content.status"
    ></idp-status>
  </div>
  <div
    [skeletonMetaData]="{
      loaded: content.options.loaded,
      error: content.options.error,
      disabled: content.options.disabled
    }"
    (action)="openLink.emit($event)"
    auraSkeletonLoader
  >
    <idp-options
      *ngIf="content.options.form"
      [content]="content.options"
      (enroll)="enroll.emit($event)"
      (closeError)="closeError.emit()"
      (selectedExtension)="selectedExtension.emit($event)"
    ></idp-options>
  </div>
</div>
<div
  [skeletonMetaData]="{
    loaded: content.footer.loaded,
    error: content.footer.error,
    disabled: content.footer.disabled
  }"
  (action)="openLink.emit($event)"
  auraSkeletonLoader
  class="rollover__faq"
>
  <idp-footer
    *ngIf="content.footer.enquiry"
    [content]="content.footer"
  ></idp-footer>
</div>
